import { Routes } from '@angular/router';
import { LoginComponent } from '../pages/login/login.component';
import { DashboardComponent } from '../pages/dashboard/dashboard.component';
import { DashboardGuard } from '../guards/dashboard.guard';
import { StatsComponent } from '../pages/dashboard/stats/stats.component';
import { SettlementsComponent } from '../pages/dashboard/settlements/settlements.component';
import { CardsComponent } from '../pages/dashboard/cards/cards.component';
import { CardComponent } from '../pages/dashboard/forms/card/card.component';
import { LimitComponent } from '../pages/dashboard/forms/limit/limit.component';
import { CardDetailsComponent } from '../pages/dashboard/card-details/card-details.component';
import { EditAccessGuard } from '../guards/edit-access.guard';

export const appRoutes: Routes = [
  {
    path:      '',
    component: LoginComponent,
    pathMatch: 'full'
  },
  {
    path:        'dashboard',
    component:   DashboardComponent,
    canActivate: [ DashboardGuard ],
    children:    [
      {
        path:       '',
        redirectTo: 'stats',
        pathMatch:  'full'
      },
      {
        path:      'stats',
        component: StatsComponent
      },
      {
        path:      'cards',
        component: CardsComponent
      },
      {
        path:      'card',
        component: CardComponent
      },
      {
        path:      'card/:id',
        component: CardComponent
      },
      {
        path:      'card/:id/details',
        component: CardDetailsComponent
      },
      {
        path:      'limit',
        component: LimitComponent
      },
      {
        path:      'limit/:id',
        component: LimitComponent,
        canActivate: [EditAccessGuard]
      },
      {
        path:      'settlements',
        component: SettlementsComponent
      }
    ]

  }
];



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/app-routing/app-routing-config.ts